<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed inset-0 overflow-hidden z-[100]" @close="emitClose()">
      <div class="absolute inset-0 overflow-hidden text-black">
        <DialogOverlay class="absolute inset-0 bg-black bg-opacity-20" />

        <div class="fixed inset-y-2 right-2 pl-10 max-w-full flex">
          <TransitionChild as="template" enter="transform transition ease-in-out duration-50 sm:duration-100" enter-from="translate-x-full" enter-to="translate-x-0" leave="transform transition ease-in-out duration-50 sm:duration-100" leave-from="translate-x-0" leave-to="translate-x-full">
            <div class="w-screen" :class="'max-w-' + maxWidth">
              <div class="h-full flex flex-col rounded-xl bg-white shadow-xl overflow-y-auto">
                <slot name="header">
                  <div class="py-6 px-4 sm:px-6 bg-primary text-white">
                    <div class="flex items-start justify-between">
                      <DialogTitle class="text-lg font-medium text-white">
                        {{ title }}
                      </DialogTitle>

                      <div class="flex-grow" />

                      <Menu as="div" class="ml-3 h-7 flex items-center relative" v-if="getActions().length > 0">
                        <MenuButton as="button" class="rounded-full p-2 text-white hover:text-gray-200 hover:bg-white hover:bg-opacity-10 focus:outline-none">
                          <EllipsisVerticalIcon class="h-6 w-6" aria-hidden="true" />
                        </MenuButton>

                        <transition enter-active-class="transition ease-out duration-200" enter-from-class="-translate-y-1 opacity-0 scale-100" enter-to-class="opacity-100 translate-y-0" leave-active-class="transition ease-in duration-75" leave-from-class="opacity-100" leave-to-class="opacity-0">
                          <MenuItems class="z-20 -top-3.5 absolute -right-2 mt-0 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 focus:outline-none overflow-hidden">
                            <div class="flex items-center text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap bg-gray-50 border-gray-200 border-b">
                              <div class="flex-grow pl-4">Aktionen</div>
                              <div class="flex-none rounded-full p-4">
                                <EllipsisVerticalIcon class="h-6 w-6" aria-hidden="true" />
                              </div>
                            </div>

                            <MenuItem
                              v-for="action of getActions()"
                              :key="action.id"
                              as="button"
                              class="w-full text-left block px-4 py-2 text-sm cursor-pointer text-gray-800 cursor-pointer hover:bg-gray-100"
                              :class="action.class"
                              @click="action.execute(action)"
                            >
                              {{ action.label }}
                            </MenuItem>

                          </MenuItems>
                        </transition>

                      </Menu>

                      <div class="ml-3 h-7 flex items-center relative">
                        <button class="rounded-full p-2 text-white hover:text-gray-200 hover:bg-white hover:bg-opacity-10 focus:outline-none" @click="emitClose()">
                          <XMarkIcon class="h-6 w-6" aria-hidden="true" />
                        </button>
                      </div>

                    </div>
                  </div>
                </slot>
                <div class="relative flex-1 p-4 sm:p-6">
                  <slot />
                </div>
              </div>
            </div>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import { Dialog, DialogOverlay, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue'

  import { Menu, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'
  import { EllipsisVerticalIcon, XMarkIcon } from '@heroicons/vue/24/solid'

  import { Action } from '../../globals/sidebar';

  export default defineComponent({
    components: {
      Dialog, DialogOverlay, DialogTitle,

      Menu, MenuButton, MenuItem, MenuItems,

      TransitionChild, TransitionRoot,

      EllipsisVerticalIcon, XMarkIcon,

    },
    props: {
      title: String,
      open: Boolean,
      maxWidth: {
        type: String,
        default: 'lg'
      },
      actions: {
        type: Array,
        default: () => [] as Array<Action>
      },
    },
    emits: [
      'close',
    ],
    methods: {
      emitClose() {
        this.$emit('close');
      },
      getActions(): Array<Action> {
        if (!this.actions) return [];

        return Array.from((this.actions as Array<Action>).filter(a => a.isVisible()));
      }
    },
  })
</script>
